import type { CSSProperties, FunctionComponent } from "react"

import styles from "./Circle.module.css"

type CircleProps = {
  percent: number
  globalYDelta: number
  globalXDelta: number
  name: string
}

export const Circle: FunctionComponent<CircleProps> = props => {
  const { percent, globalYDelta, globalXDelta, name } = props

  return (
    <li
      className={styles.main}
      style={
        {
          "--CircleCurrentSize": percent,
          "--GlobalXDelta": `${globalXDelta}px`,
          "--GlobalYDelta": `${globalYDelta}px`,
        } as CSSProperties
      }
    >
      <span className="sr-only">{name} :</span> {percent}%
    </li>
  )
}
